import { captureError, withScope } from '@lingoda/monitor';

export const captureMercureError: typeof captureError = (error, data) => {
    withScope((scope) => {
        scope.setTransactionName('mercure-event-source');

        captureError(error, { mercure: data });
    });
};
